<template>
  <div class="contango-pay-apply-wrap congtango-dialog">
    <el-dialog
      title="挂牌商品履约金解冻申请"
      :visible.sync="dialogVisible"
      width="450px"
      :append-to-body="true"
      custom-class="contango-pay-apply-wrap"
      :before-close="handleClose"
      >
      <div class="content">
        <div class="item">
          <div class="label">订单编号:</div>
          <div class="text">{{ detailData.orderCode }}</div>
        </div>
        <div class="item">
          <div class="label">升贴水单价:</div>
          <div class="text">{{ detailData.liftingWater }}</div>
        </div>
        <div class="item">
          <div class="label">订单数量:</div>
          <div class="text">{{ detailData.orderQuantity }}吨</div>
        </div>
        <div class="item">
          <div class="label">挂牌商品履约金总额:</div>
          <div class="text">{{ detailData.canThawDepositSum }}元</div>
        </div>
        <div class="item">
          <div class="label">可解冻金额:</div>
          <div class="text">{{ detailData.canThawDeposit }}元</div>
        </div>
        <div class="item">
          <div class="label">已解冻金额:</div>
          <div class="text">{{ detailData.applyThawDepositSum }}元</div>
        </div>
        <div class="item">
          <div class="label">品类单价:</div>
          <div class="text" :style="{'text-decoration': detailData.sellerDepositRate > 0 && detailData.sellerDepositRate !== 100 ? 'line-through' : ''}">
            {{ detailData.categoryPrice }}元
          </div>
        </div>
        <div class="tip-button price-tip" v-if="detailData.sellerDepositRate > 0 && detailData.sellerDepositRate !== 100">
          <i class="el-icon-info"></i>履约金优惠折扣为{{ detailData.sellerDepositRate }}%
          最终为<br>{{ detailData.categoryPrice * detailData.sellerDepositRate * 0.01 }}元
        </div>
        <div class="item input_item">
          <div class="label">申请解冻金额:</div>
          <div class="text">
            <el-input
              placeholder="请输入申请解冻金额"
              v-model="applyThawDeposit" @input="formatNumber"
              onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))" />
          </div>
        </div>
        <div class="tip-button"><i class="el-icon-info"></i>以品类单价倍数起输入</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="confirm-button" type="primary" @click="submit">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'ThawAmountApply',
  props: {
    rowData: { // 行数据
      type: Object,
      default: () => {},
      isRequired: true
    },
    isEdit: { // 是否是编辑
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogVisible: true,
      detailData: {}, // 详情数据
      applyThawDeposit: '', // 申请解冻金额
    }
  },
  mounted () {
    this.getDetails()
    if (this.isEdit) { // 编辑的时候带入数据
      this.applyThawDeposit = this.rowData.applyThawDeposit
    }
  },
  methods: {
    // 获取订单详情数据
    getDetails () {
      const url = this.$API.myOrder.contangoThawDeposit
      const param = {
        orderCode: this.rowData.orderCode
      }
      this.$http.post(url, param).then(res => {
        this.detailData = res.data
      })
    },
    // 格式化输入金额
    formatNumber () {
      this.applyPayAmount = ~~this.applyPayAmount // 去掉金额的前置0，比如将‘00022’变成‘22’
    },
    // 提交申请
    submit () {
      if (!this.applyThawDeposit || !(Number(this.applyThawDeposit) > 0)) {
        this.$message.error('请输入大于0的申请解冻金额')
      } else {
        const url = this.isEdit ? this.$API.myOrder.editPCThawDeposit : this.$API.myOrder.addThawDeposit
        const param = {
          orderCode: this.rowData.orderCode, // 订单编号
          applyThawDeposit: this.applyThawDeposit, // 申请解冻金额
          canThawDepositSum: this.detailData.canThawDepositSum // 可解冻总金额
        }
        if (this.isEdit) { // 编辑的时候带一个id过去
          param.id = this.rowData.id
        }
        this.$http.post(url, param).then(() => {
          this.$message.success('申请成功')
          if (this.isEdit) {
            this.$emit('retrieve') // 编辑成功后刷新表格数据
          }
          this.handleClose()
        })
      }
    },
    // 关闭弹窗
    handleClose () {
      this.$emit('done')
    }
  }
}
</script>

<style lang="scss" scoped>
  .contango-pay-apply-wrap{
    /deep/ .el-dialog__footer{
      text-align: center;
      padding-top: 0;
      padding-bottom: 27px;
    }
    .content{
      padding: 0 12px;
      .item{
        overflow: hidden;
        margin-bottom: 14px;
        div{
          float: left;
          overflow: hidden;
          color: rgba(51,51,51,0.94);
          font-size: 14px;
        }
        .label{
          width: 155px;
          text-align: left;
        }
      }
      .input_item{
        line-height: 55px;
        /deep/ input{
          height: 38px;
          width: 190px;
        }
      }
    }
    .confirm-button{
      background: #ff7f00;
      height: 48px;
      width: 300px;
      color: rgba(255,255,255,0.94);
      font-size: 20px;
    }
    .tip-button{
      font-size: 12px;
      color: #e6a23c;
      margin-top: -20px;
      margin-left: 155px;
      text-align: left;
      i{
        margin-right: 8px;
      }
    }
    .price-tip{
      margin-top: -15px;
    }
  }
</style>
